import * as Servlet from '../../common/servlet'
import * as Common from '../../common/common'
import axios from "axios";
import Highcharts from 'highcharts'
import { getRainfallMinMax } from '../../common/minMaxCommon.js'
import $ from 'jquery';
window.jQuery = $
window.$ = $

let rfobscd = "";

const sortOrder = ["0101", "0102", "0103", "0104", "0105", "0106"];
const urlParams = new URL(location.href).searchParams;

/***************************************************
************ DOM 로드 후 초기화 함수 호출 **********
***************************************************/
window.addEventListener('DOMContentLoaded', (event) => {
	if (urlParams.get('type') !== null) {
		document.querySelector('.title2').style.display = 'block';
		document.querySelector('.title').style.display = 'none';

		const titleSpan = document.querySelector('.cont-title span:nth-child(2)');
		titleSpan.innerHTML = '&nbsp;' + sessionStorage.getItem('TITLE.rf.agency.list');
	}

	const rmststs = Servlet.lsttm() // 현재 시간 이전 시간 값 가져옴 
	rmststs.then((result) => {
		document.getElementById('lsttm').value = result[0].lsttm

		// 날짜 세팅
		Common.set1DayTime2sc()

		const getHour = result[0].lsttm.substring(8, 10)
		const getMin = result[0].lsttm.substring(10, 12)

		Common.selectMakeHour('scSHour', getHour)
		Common.selectMakeMin('scSMin', getMin)
		Common.selectMakeHour('scEHour', getHour)
		Common.selectMakeMin('scEMin', getMin)

		let limit = sessionStorage.getItem("MSG.search.period.limit");
		let searchWord = limit.replace("<N>", "14");
		let searchLimit = document.getElementById("searchLimit");
		searchLimit.innerText = "· " + searchWord;
	}).then(() => {
		selectStation();
		rainfallData();
	})
});

// 스테이션 select 목록 생성
function selectStation() {
	let station = document.getElementById("stationSelect");
	let filteredData = [];
	let html = "";
	let rfParam = makeMstParam();
	var agccd = urlParams.get('type') == null ? '-' : (urlParams.get('type') === 'Pjt' ? '0103' : '0104')

	let request;

	if (agccd === '-') {
		request = axios.post(`/rainfall/RfIfList/agccd/bsncd`, new URLSearchParams({ agccd: 'all', bsncd: 'all' }));
	} else {
		request = axios.post(`/rainfall/exRfobsList/agccd/edt`, new URLSearchParams({ agccd: agccd, sdt: rfParam.ymdhm.sdt, edt: rfParam.ymdhm.edt }));
	}

	axios.all([
		request
	]).then(axios.spread((rfinfoResponse) => {
		const rfinfo = rfinfoResponse.data.resultData;
		filteredData = agccd == '-' ? rfinfo.filter(el => el.usecd === "1001" && el.hpdspcd === "1001") : rfinfo;

		if (filteredData != null) {
			filteredData.sort(function(a, b) {
				if (a.obsnm.toLowerCase() < b.rfobscd.toLowerCase()) return -1;
				if (a.obsnm.toLowerCase() > b.rfobscd.toLowerCase()) return 1;
				return 0;
			});
		}

		html += "<option value='" + 'all' + "'>" + sessionStorage.getItem("TITLE.station") + "</option>";
		if (filteredData != null) {
			filteredData.forEach((info, i) => {
				// 조건: 수동 관측소이면서 수동자료 홈페이지 표출 여부가 N일 때 목록 표출 X
				if (!(info.obsdvcd === "1102" && info.mdathpdspcd === "1002")) {
					html += "<option value='" + info.rfobscd + "'>" + info.obsnm + "</option>";
				}
			});
		}

		station.innerHTML = html;
	}));
}

/***************************************
********** 왼쪽 데이터 관련 ************
****************************************/
// 강우 데이터 받아오기
const rainfallData = function() {
	showLoading();

	let rfParam = makeMstParam();
	let filteredData = [];

	if (urlParams.get('type') !== null) {
		var agccd = urlParams.get('type') === 'Pjt' ? '0103' : '0104';
		axios.post(`/rainfall/exRfobsList/agccd/edt`, new URLSearchParams({ agccd: agccd, sdt: rfParam.ymdhm.sdt, edt: rfParam.ymdhm.edt }))
			.then(response => {
				var rfinfo = response.data.length == 0 ? null : response.data.resultData;
				let select = document.getElementById("stationSelect").value;
				if (select == "all" || select == "") {
					filteredData = rfinfo
				} else {
					filteredData = rfinfo.filter(info => info.rfobscd === select);
				}

				if (filteredData != null) {
					filteredData.forEach((val, idx) => {
						if (filteredData[idx].rf != null && filteredData[idx].rf <= -999) {
							val.rf = null;
						}
					});

					filteredData.sort((a, b) => {
						const indexA = sortOrder.indexOf(a.agccd);
						const indexB = sortOrder.indexOf(b.agccd);

						if (indexA !== indexB) {
							return indexA - indexB; // agccd 순서대로 정렬
						} else {
							return a.obsnm.localeCompare(b.obsnm); // 같은 그룹 내에서는 obsnm 기준 정렬
						}
					});

				}

				rfLeftTable(filteredData);

				hideLoading();
			})

	} else {
		axios.all([
			axios.post(`/rainfall/RfIfList/agccd/bsncd`, new URLSearchParams({ agccd: 'all', bsncd: 'all' })), // 관측소 정보
			axios.post(`/rainfall/Mst/ymdhm`, new URLSearchParams({ now: rfParam.ymdhm.edt })), // 현재 시간 우량
			axios.post(`/rainfall/ManualMstYmd/ymd`, new URLSearchParams({ ymd: rfParam.ymd.edt })), // 수동 우량
			axios.post(`/basin/Fbs/Info`),	// 권역
			axios.post("/servlet/fbscd/getSfgbifList"), // 대유역코드 조회
			axios.post("/servlet/fbscd/getAllSfmbifList") // 중유역코드 조회
		]).then(axios.spread((rfinfoResponse, rfmstResponse, rfmnResponse, fbsInfoResponse, sgbResponse, smbResponse) => {
			const rfinfo = rfinfoResponse.data.resultData;
			const rfmst = rfmstResponse.data.resultData;
			const rfmnmst = rfmnResponse.data.resultData;
			const fbsInfo = fbsInfoResponse.data.resultData;
			const sgbInfo = sgbResponse.data;
			const smbInfo = smbResponse.data;

			let select = document.getElementById("stationSelect").value;
			if (select == "all" || select == "") {
				filteredData = rfinfo.filter(info =>
					!(info.obsdvcd === "1102" && info.mdathpdspcd === "1002") // 수동 관측소이면서 수동자료 홈페이지 표출 여부가 N일 때 목록 표출 X
				);
			} else {
				filteredData = rfinfo.filter(info => info.rfobscd === select);
			}

			filteredData.forEach((info, i) => {
				try {
					const rfmst_data = rfmst.find(el => el.rfobscd === info.rfobscd);

					info.ymdhm = Common.getDateTime2Separator(rfmst_data.ymdhm, '-');
					info.rf = rfmst_data.rf;
				} catch (e) { }

				try {
					const rfmnmst_data = rfmnmst.find(el => el.rfobscd === info.rfobscd);

					info.ymdh = Common.getDateTime2Separator(rfmnmst_data.ymdh, '-');
					info.rfmn = rfmnmst_data.rf;
				} catch (e) { }

				try {
					const fbsinfo_data = fbsInfo.find(el => el.fbscd === info.fbscd);
					const smbInfo_data = smbInfo.find(el => el.fmbcd === info.fmbcd);

					info.fmbnm = smbInfo_data.fmbnm;
					info.fbsnm = fbsinfo_data.fbsnm;
				} catch (e) { }
			})

			filteredData.sort((a, b) => {
				return a.rfobscd.localeCompare(b.rfobscd);
			});
		})).then(() => {
			rfLeftTable(filteredData);
		}).finally(() => {
			hideLoading();
		})
	}
}

// 왼쪽 지점 목록 테이블 생성
function rfLeftTable(result) {
	const urlSearch = new URLSearchParams(location.search);
	const urlObscd = urlSearch.get('obscd');

	let tbody = document.getElementById("rfTbody");
	let paramYmdhm;
	let html = "";

	if (result == null) {
		html += '<tr>';
		html += '    <td colspan="4">No data available.</td>';
		html += '</tr>';

		tbody.innerHTML = html;

		return false;
	}

	//정렬순으로 목록 표출
	result.forEach((info, i) => {
		let rf = (info.rf == undefined || info.rf == null) ? "-" : Number(info.rf).toFixed(1);
		let ymdhm = "-";
		let ymdh = "-";
		let rfmn = (info.rfmn == undefined || info.rfmn == null) ? "-" : Number(info.rfmn).toFixed(1);
		let selectedClass = '';
		let fmbnm = (info.fmbnm == undefined || info.fmbnm == null) ? "-" : info.fmbnm;

		if (info.rfobscd === rfobscd || info.rfobscd === urlObscd) {
			selectedClass = 'selected';
		}


		if (info.ymdhm) ymdhm = info.ymdhm;
		if (info.ymdh) ymdh = info.ymdh;

		html += "<tr id='" + info.rfobscd + "' class='" + selectedClass + "'>";
		html += "	<td>" + info.obsnm + "</td>";
		html += "	<td>" + fmbnm + "</td>";
		if (info.obsdvcd === "1102") { // 수동 우량
			html += "	<td>" + ymdh + "</td>";
			html += "	<td>" + rfmn + "</td>";
		} else {
			html += "	<td>" + ymdhm + "</td>";
			html += "	<td>" + rf + "</td>";
		}

		html += "</tr>";
	})

	tbody.innerHTML = html;

	let selected = tbody.querySelector('tr.selected');
	if (!selected) {
		let selectedTr = tbody.firstChild;
		if (selectedTr && urlObscd == null) {
			selectedTr.classList.add("selected");
			rfobscd = selectedTr.id;
			paramYmdhm = selectedTr.ymdhm
		}
	}

	if (urlObscd != null) {
		rfobscd = urlObscd;
	}

	rfDetailData(rfobscd, paramYmdhm);
}

/*****************************************
********** 오른쪽 데이터 관련 ************
*****************************************/
// 해당 기간에 대한 정보 불러오기
const rfDetailData = function(rfobscd, paramYmdhm) {
	let param = makeMstParam();

	/////외부기관
	if (urlParams.get('type') !== null) {
		var nYMD = paramYmdhm === undefined ? param.ymdhm.edt : (paramYmdhm != '-' ? paramYmdhm.substring(0, 4) + paramYmdhm.substring(5, 7) + paramYmdhm.substring(8, 10) + paramYmdhm.substring(11, 13) + paramYmdhm.substring(14, 16) : param.edt);

		Common.axios.all([
			Common.axiosApi.post(`/external/Info/${rfobscd}`),
			Common.axiosApi.post(`/external/Rainfall/Mst/${rfobscd}/${param.ymdhm.edt}`),
			Common.axiosApi.post(`/external/Rainfall/Mst/${rfobscd}/${param.ymdhm.sdt}/${nYMD}`),
			Common.axiosApi.post(`/external/Info/5001/all/all`)
		]).then(Common.axios.spread((...resList) => {
			var timeArr;
			let sumrf = 0;

			try {
				resList[0] = resList[3].find(el => el.obscd == rfobscd)
				var obsnm = resList[0].obsnm;

				if (resList[2] != null) {
					timeArr = [];
					for (var i = 0; i < resList[2].length; i++) {
						var temp = resList[2][i];

						var mrf = null;
						sumrf += isNaN(temp.rf) ? 0 : Number(temp.rf);
						var rf = isNaN(temp.rf) ? null : Number(temp.rf);

						timeArr.push({ ymdhm: temp.ymdhm, rf: rf, obsnm: obsnm });
					}

				} else {
					timeArr = [];
					timeArr.push({ ymdhm: null, rf: null, obsnm: obsnm });
				}

				rfRightTable(timeArr, resList[0]);
				makeChartParam(timeArr, resList[0]);
			} catch (e) {
			}

		})).catch((err) => console.error(err))

	} else {
		Common.axios.all([
			Common.axiosApi.post(`/rainfall/Info/${rfobscd}`), // 관측소 정보
			Common.axiosApi.post(`/rainfall/Mst/${rfobscd}/${param.ymdhm.sdt}/${param.ymdhm.edt}`), // 기간 강우량
			Common.axiosApi.post(`/rainfall/MenualMst/${rfobscd}/${param.ymdh.sdt}/${param.ymdh.edt}`), // 기간 수동 측정 강우량
		]).then(Common.axios.spread((rfinfo, mst, m_mst) => {
			let sumrf = 0; // 자동 우량 합계
			let summrf = 0; // 수동 우량 합계

			let timeArr = Common.get10mTimeJsonArray(`${param.ymdhm.sdt}`, `${param.ymdhm.edt}`);
			timeArr.forEach((val, i) => {  // 관측소 코드가 일치하는 자료들을 세팅
				try {
					val.rf = "-";   // 결측데이터에 대비해서 값 미리 세팅
					val.sumrf = "-"; // 결측데이터에 대비해서 값 미리 세팅

					const mst_data = mst.find(el => el.ymdhm === val.ymdhm)
					if (mst_data != null) {
						sumrf += Number(mst_data.rf)
						val.rf = Number(mst_data.rf)
					} else {
						sumrf += 0; // 데이터가 없을 때 0을 더함
					}
					val.sumrf = sumrf;

					val.obsnm = rfinfo.obsnm;
				} catch (e) { }

				try {
					val.mrf = "-";   // 결측데이터에 대비해서 값 미리 세팅
					val.summrf = "-";
					const m_mst_data = m_mst.find(el => el.ymdh + '00' === val.ymdhm)
					if (m_mst_data != null && rfinfo.mdathpdspcd === "1001") {
						summrf += Number(m_mst_data.rf)
						val.mrf = Number(m_mst_data.rf)
					} else {
						summrf += 0; // 데이터가 없을 때 0을 더함
					}
					val.summrf = summrf;
				} catch (e) { }


			});

			rfRightTable(timeArr, rfinfo);
			makeChartParam(timeArr, rfinfo);
		})).catch((err) => console.error(err))
	}
}

//오른쪽 상세정보 테이블 생성
function rfRightTable(result, rfinfo) {
	result.reverse();

	const table = document.querySelector('#rightTable');
	const { obsdvcd } = rfinfo;
	const { mdathpdspcd } = rfinfo;
	const session = sessionStorage;
	let html = ""

	if (urlParams.get('type') !== null) {
		const tableHeaders = {
			"ex": { // 자동
				cols: 2,
				headers: [
					session.getItem("TABLE.ymdhm"),
					`${session.getItem("TABLE.rf")}(mm)`,
				]
			}
		};

		const { cols, headers } = tableHeaders["ex"];
		html += `<caption></caption><colgroup>${'<col width="23%">'.repeat(cols)}</colgroup><thead><tr>`;
		html += headers.map(header => `<th scope="col">${header}</th>`).join('');
		html += "</tr></thead><tbody>";
	} else {
		const tableHeaders = {
			"1101": { // 자동
				cols: 3,
				headers: [
					session.getItem("TABLE.ymdhm"),
					`${session.getItem("TABLE.rf")}(mm)`,
					`${session.getItem("TITLE.rf.accumulated")}(mm)`
				]
			},
			"1102": { // 수동
				cols: 3,
				headers: [
					session.getItem("TABLE.ymdhm"),
					`${session.getItem("TABLE.mnl.rf")}(mm)`,
					`${session.getItem("TITLE.rf.accumulated")}(mm)`
				]
			},
			"1103": { // 자동, 수동
				cols: 4,
				headers: [
					session.getItem("TABLE.ymdhm"),
					`${session.getItem("TABLE.mnl.rf")}(mm)`,
					`${session.getItem("TABLE.rf")}(mm)`,
					`${session.getItem("TITLE.rf.accumulated")}(mm)`
				]
			}
		};

		const { cols, headers } = (obsdvcd === "1101" || (obsdvcd === "1103" && mdathpdspcd === "1002"))
			? tableHeaders["1101"]
			: tableHeaders[obsdvcd];
		html += `<caption></caption><colgroup>${'<col width="23%">'.repeat(cols)}</colgroup><thead><tr>`;
		html += headers.map(header => `<th scope="col">${header}</th>`).join('');
		html += "</tr></thead><tbody>";
	}

	result.forEach((info, i) => {
		let mrf = (info.mrf == null || info.mrf == undefined || isNaN(info.mrf)) ? "-" : Number(info.mrf).toFixed(1);
		let rf = (info.rf == null || info.rf == undefined || isNaN(info.rf)) ? "-" : Number(info.rf).toFixed(1);
		let sumrf = (info.sumrf == null || info.sumrf == undefined || isNaN(info.sumrf)) ? "-" : Number(info.sumrf).toFixed(1);
		let ymdhm = (info.ymdhm == null || info.ymdhm == undefined || isNaN(info.ymdhm)) ? "-" : Common.getDateTime2Separator(info.ymdhm, '-');
		if (urlParams.get('type') !== null) {
			html += "<tr>";
			html += "	<td>" + ymdhm + "</td>";
			html += `<td>${rf}</td>`;
			html += "<tr>";
		} else {
			html += "<tr>";
			html += "	<td>" + ymdhm + "</td>";
			if (obsdvcd === "1101" || (obsdvcd === "1103" && mdathpdspcd === "1002")) { // 자동 혹은 자동, 수동 관측소이면서 수동 자료 표출여부가 N일 경우
				html += `<td>${rf}</td><td>${sumrf}</td>`;
			} else if (obsdvcd === "1102") { // 수동
				html += `<td>${mrf}</td><td>${summrf}</td>`;
			} else if (obsdvcd === "1103") { // 자동, 수동
				html += `<td>${mrf}</td><td>${rf}</td><td>${sumrf}</td>`;
			}
			html += "<tr>";
		}
	});
	html += "</tbody>";

	table.innerHTML = html;

	insertTitle(rfinfo.obsnm);
}

// 차트 Param값 생성
function makeChartParam(result, rfinfo) {
	let obsnm = "";
	let obsdvcd = "";
	let timeArr = [];
	let rfArr = [];
	let sumrfArr = [];
	let mrfArr = [];
	let summrfArr = [];

	result.reverse();
	result.forEach((info, i) => {
		let ymdhm = (info.ymdhm == null || info.ymdhm == undefined) ? "" : info.ymdhm;
		let year = ymdhm.substring(0, 4);
		let month = ymdhm.substring(4, 6);
		let day = ymdhm.substring(6, 8);
		let hour = ymdhm.substring(8, 10);
		let min = ymdhm.substring(10, 12);
		let rf = (info.rf == null || info.rf == undefined) ? "" : info.rf;
		let sumrf = (info.sumrf == null || info.sumrf == undefined) ? "" : info.sumrf;
		let mrf = (info.mrf == null || info.mrf == undefined) ? "" : info.mrf;
		let summrf = (info.summrf == null || info.summrf == undefined) ? "" : info.summrf;

		timeArr.push(Date.UTC(year, month - 1, day, hour, min));
		rfArr.push(rf);
		sumrfArr.push(sumrf);
		mrfArr.push(mrf);
		summrfArr.push(summrf);
	});

	obsnm = (rfinfo.obsnm == null) ? obsnm = "" : obsnm = rfinfo.obsnm;
	obsdvcd = (rfinfo.obsdvcd == null) ? obsdvcd = null : obsdvcd = rfinfo.obsdvcd; // 자동, 수동 세팅

	drawChart(obsdvcd, obsnm, timeArr, rfArr, sumrfArr, mrfArr, summrfArr, rfinfo);
}

// 차트 생성
function drawChart(obsdvcd, obsnm, timeArr, rfArr, sumrfArr, mrfArr, summrfArr, rfinfo) {
	const minmax = getRainfallMinMax(obsdvcd, rfArr, mrfArr, sumrfArr, summrfArr)
	const seriesData = [];

	// 자동, 수동, 자동/수동 여부에 따른 차트 선 표출
	if (obsdvcd === "1101") {
		// 자동
		seriesData.push({
			name: sessionStorage.getItem("TABLE.rf") + "(mm)",
			type: "column",
			//			color: "#0070c0",
			color: "#2d6aa8",
			yAxis: 0,
			borderWidth: 0,
			data: rfArr,
			tooltip: {
				valueSuffix: "mm",
				valueDecimals: 1
			}
		});

		if (urlParams.get("type") === null) {
			seriesData.push({
				name: sessionStorage.getItem("TITLE.rf.accumulated") + "(mm)",
				type: "spline",
				//			color: "#cc00cc",
				color: "#008000",
				yAxis: 1,
				data: sumrfArr,
				tooltip: {
					valueSuffix: "mm",
					valueDecimals: 1
				},
				marker: {
					symbol: 'triangle-down' // 모양 설정: 원
				}
			});
		}
	} else if (obsdvcd === "1102") {
		// 수동
		seriesData.push({
			name: sessionStorage.getItem("TABLE.mnl.rf") + "(mm)",
			type: "line",
			marker: {
				symbol: 'diamond', // 마커 사각형
			},
			//legendSymbol: 'diamond', // 범례 사각형으로 변경
			//			color: "#9bbb59",
			color: "#fde700",
			yAxis: 0,
			borderWidth: 5,
			lineWidth: 5,
			data: mrfArr,
			tooltip: {
				valueSuffix: "mm",
				valueDecimals: 1 // 소수점 1자리
			}
		});
		if (urlParams.get("type") === null) {
			seriesData.push({
				name: sessionStorage.getItem("TITLE.rf.accumulated") + "(mm)",
				type: "spline",
				//			color: "#cc00cc",
				color: "#008000",
				yAxis: 1,
				data: summrfArr,
				tooltip: {
					valueSuffix: "mm",
					valueDecimals: 1
				},
				marker: {
					symbol: 'triangle-down' // 모양 설정: 원
				}
			});
		}
	} else if (obsdvcd === "1103") {
		// 자동, 수동
		seriesData.push({
			name: sessionStorage.getItem("TABLE.rf") + "(mm)",
			type: "column",
			//			color: "#0070c0",
			color: "#2d6aa8",
			yAxis: 0,
			borderWidth: 0,
			data: rfArr,
			tooltip: {
				valueSuffix: "mm",
				valueDecimals: 1
			}
		});

		if (rfinfo.mdathpdspcd === "1001") { // 수동 자료 표출이 1001일때만 표출
			seriesData.push({
				name: sessionStorage.getItem("TABLE.mnl.rf") + "(mm)",
				type: "line",
				marker: {
					symbol: 'diamond', // 마커 사각형
				},
				//legendSymbol: 'diamond', // 범례 사각형으로 변경
				//			color: "#9bbb59",
				color: "#fde700",
				yAxis: 0,
				borderWidth: 5,
				lineWidth: 5,
				data: mrfArr,
				tooltip: {
					valueSuffix: "mm",
					valueDecimals: 1 // 소수점 1자리
				}
			});
		}
		if (urlParams.get("type") === null) {
			seriesData.push({
				name: sessionStorage.getItem("TITLE.rf.accumulated") + "(mm)",
				type: "spline",
				//			color: "#cc00cc",
				color: "#008000",
				yAxis: 1,
				data: sumrfArr,
				tooltip: {
					valueSuffix: "mm",
					valueDecimals: 1
				},
				marker: {
					symbol: 'triangle-down' // 모양 설정: 원
				}
			});
		}
	}

	// 차트 생성
	$("#cData").highcharts({
		title: {
			text: obsnm
		},
		credits: {
			enabled: false
		},
		accessibility: { // 경고창 숨김
			enabled: false
		},
		xAxis: [{
			gridLineWidth: 1,
			gridLineDashStyle: 'ShortDot',
			lineWidth: 1,
			type: "datetime",
			labels: {
				formatter: function() {
					return Highcharts.dateFormat('%d-%H:%M', this.value);
				},
			},
			title: {
				text: "",
			},
			legend: {
				// 범례 사용안함
				enabled: false,
			},
			categories: timeArr,
			tickInterval: Math.floor(timeArr.length / 8), //12
		}],
		yAxis: [{
			title: {
				text: sessionStorage.getItem("TABLE.rf") + " (mm)",
				align: "middle",
			},
			labels: {
				formatter: function() {
					return Highcharts.numberFormat(this.value, 1);
				}
			},
			reversed: false, // 막대그래프 상하 반전
			gridLineWidth: 1,
			gridLineDashStyle: 'ShortDot',
			lineWidth: 1,
			tickAmount: 6,
			min: minmax.rainfallMin,
			max: minmax.rainfallMax,
		}, {
			title: {
				text: sessionStorage.getItem("TITLE.rf.accumulated") + " (mm)",
				align: "middle",
			},
			labels: {
				formatter: function() {
					return Highcharts.numberFormat(this.value, 1);
				}
			},
			tickAmount: 6,
			min: minmax.sumRainfallMin,
			max: minmax.sumRainfallMax,
			opposite: true,
			gridLineWidth: 1,
			gridLineDashStyle: 'ShortDot',
			lineWidth: 1,
			reversed: false, // 막대그래프 상하 반전
		}],
		tooltip: {
			//xDateFormat: "%m-%d %H:%M",
			//footerFormat: "</table>",
			formatter: function() {
				const date = new Date(this.x);
				date.setHours(date.getHours() - 9);

				var uni = ['\u25A0', '\u25C6', '\u25BC']

				var s = `${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)} ${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}` + '<br>'


				$.each(this.points, function(i, point) {

					if (point.y !== undefined && point.y !== null) {
						var num = 0;
						var color = point.color;

						if (color == '#2d6aa8') num = 0;
						else if (color == '#fde700') num = 1;
						else if (color == '#008000') num = 2;

						s += '<span style="color:' + point.color + '">' + uni[num] + '</span>' + point.series.name + ' : ' + point.y.toFixed(1) + ' ' + point.series.tooltipOptions.valueSuffix + "<br>";
					}
				});
				return s;
			},
			valueDecimals: 2,
			shared: true,
			crosshairs: true,
			enabled: true,
			useHTML: true,
			followPointer: true, // 툴팁이 마우스 따라다니게
			style: {
				fontWeight: 'bold',  // 글자 굵게 설정
			}
		},
		legend: {
			verticalAlign: 'top',
			squareSymbol: true,
			symbolRadius: 0,
			symbolWidth: 20,
			itemStyle: {
				color: 'var(--color-chart-title)',
			}
		},
		plotOptions: {
			spline: {
				lineWidth: 2,
				states: {
					hover: {
						lineWidth: 3,
					},
				},
				marker: {
					enabled: false
				}
			},
		},
		series: seriesData,
	})
}

/**************************************
********** Param 생성 관련 ************
***************************************/
// Mst의 sdt, edt 값 생성
const makeMstParam = function() {
	let scSDate = document.getElementById("scSDate").value;
	let replacescSDate = scSDate.replaceAll("-", "");
	let scSHour = document.getElementById("scSHour").value;
	let scSMin = document.getElementById("scSMin").value;
	let sdt = replacescSDate + scSHour + scSMin;
	let sYmd = replacescSDate;
	let sYmdh = replacescSDate + scSHour;

	let scEDate = document.getElementById("scEDate").value;
	let replacescEDate = scEDate.replaceAll("-", "");
	let scEHour = document.getElementById("scEHour").value;
	let scEMin = document.getElementById("scEMin").value;
	let edt = replacescEDate + scEHour + scEMin;
	let eYmd = replacescEDate;
	let eYmdh = replacescEDate + scEHour;

	// 년월일
	const ymd = { sdt: sYmd, edt: eYmd };
	const ymdh = { sdt: sYmdh, edt: eYmdh };
	const ymdhm = { sdt: sdt, edt: edt };

	return { ymd: ymd, ymdh: ymdh, ymdhm: ymdhm };
}

/*******************************
********** 검색관련 ************
********************************/
// 검색버튼 눌렀을 때
$(document).on("click", "#searchBtn", function() {
	let param = makeMstParam();
	let sdt = param.ymdhm.sdt;
	let edt = param.ymdhm.edt;

	const dateStart = new Date(Common.getDateTime2SeparatorforDate(sdt));
	const dateEnd = new Date(Common.getDateTime2SeparatorforDate(edt));

	// 기간 제한 설정 (14일)
	Common.checkDateDiff(dateStart, dateEnd, "week").then((res) => {
		if (!res) return;

		rainfallData();
	})
});

$(document).on("change", "#stationSelect", function() {
	let param = makeMstParam();
	let sdt = param.ymdhm.sdt;
	let edt = param.ymdhm.edt;

	const dateStart = new Date(Common.getDateTime2SeparatorforDate(sdt));
	const dateEnd = new Date(Common.getDateTime2SeparatorforDate(edt));

	// 기간 제한 설정 (14일)
	Common.checkDateDiff(dateStart, dateEnd, "week").then((res) => {
		if (!res) return;

		rainfallData();
	})
});

// 다운로드 버튼 눌렀을 때
$(document).on("click", "#downloadBtn", function() {
	var agccd = urlParams.get('type') == null ? '-' : (urlParams.get('type') === 'Pjt' ? '0103' : '0104');

	let selectedId;
	let param = makeMstParam();
	let sdt = param.ymdhm.sdt;
	let edt = param.ymdhm.edt;

	// 선택된 tr의 id 값 가져오기 (관측소 코드)
	const trElements = document.querySelectorAll('tr');
	trElements.forEach(function(trElement) {
		if (trElement.classList.contains('selected')) {
			selectedId = trElement.id;
		}
	});

	// 다운로드 페이지로 이동
	if (agccd == '-') {
		window.location.href = "/page/download/download.html?type=1801&obscd=" + selectedId + "&sdt=" + sdt + "&edt=" + edt + "&agccd=0101"
	} else {
		window.location.href = "/page/download/download.html?type=1801&obscd=" + selectedId + "&sdt=" + sdt + "&edt=" + edt + "&agccd=" + agccd
	}

});

/********************************************
********** 기타 이벤트 기능 관련 ************
********************************************/
// 클릭 시 테이블 색 변경
$(document).on("click", "tbody#rfTbody tr", function() {
	$("tbody#rfTbody tr").removeClass("selected");
	$(this).addClass("selected");
});

// 마우스 커서 올라가 있을때 색 및 포인터 변경
$(document).on("mouseover", "tbody#rfTbody tr", function() {
	$(this).children("td").css("cursor", "pointer");
});

// 왼쪽 테이블 클릭시 테이블 생성
$(document).on("click", "#rfTable tr", function(event) {
	let param = makeMstParam();
	let sdt = param.ymdhm.sdt;
	let edt = param.ymdhm.edt;

	const dateStart = new Date(Common.getDateTime2SeparatorforDate(sdt));
	const dateEnd = new Date(Common.getDateTime2SeparatorforDate(edt));

	// 기간 제한 설정 (14일)
	Common.checkDateDiff(dateStart, dateEnd, "week").then((res) => {
		if (event.target.closest('thead')) {
			return;
		} else {
			rfobscd = $(this).attr("id");
			rfDetailData(rfobscd);
		}
	})
});

const insertTitle = function(obsnm) {
	const parentElement = document.querySelectorAll(".wrap.rf .right");
	parentElement.forEach((info, i) => {
		let checkClass = info.querySelector(".i");

		if (!checkClass) {
			let childClass = info.querySelector(".table");
			let newElement = document.createElement("span");
			newElement.classList.add("i");
			newElement.textContent = "· " + obsnm + " " + sessionStorage.getItem("TITLE.rf.data");

			info.insertBefore(newElement, childClass);
		} else {
			checkClass.textContent = "· " + obsnm + " " + sessionStorage.getItem("TITLE.rf.data");
		}
	});
}
